import React, { ChangeEvent } from "react"
import { withStyles } from "@material-ui/core/styles"
import { AppLinkMui } from "@ecom/ui/components/AppLink"
import Checkbox from "@material-ui/core/Checkbox"
import FormHelperText from "@material-ui/core/FormHelperText"
import { FormikTouched } from "formik"
import clsx from "clsx"
import { WrapperDataLayer } from "./WrapperDataLayer"

import * as styles from "./fields.module.scss"
import type { TFormVariant } from "../../types"
import { CheckedRedesignIcon } from "../icons/CheckedRedesignIcon"
import { EmptyRedesign } from "../icons/EmptyRedesign"

type Props = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  value: boolean
  name: string
  id: string
  error?: string
  touched?: FormikTouched<{}>
  variant?: TFormVariant
}

const CustomCheckbox = withStyles({
  root: {
    "&:hover svg path:first-child": {
      fill: "#FF3B5B !important",
      transition: "all 0.2s e ase",
    },
  },
})(Checkbox)

export const AcceptmentFieldRedesign = ({
  value,
  variant = "standart",
  error,
  name,
  touched,
  ...props
}: Props) => (
  <WrapperDataLayer isChanged={value} touched={touched} error={error} name={name}>
    <div className={styles.acceptmentWrapper}>
      <div className={styles.acceptment}>
        <div className={clsx(styles.checkbox, styles[variant])}>
          <CustomCheckbox
            checkedIcon={<CheckedRedesignIcon />}
            icon={<EmptyRedesign />}
            checked={value}
            {...props}
          />
        </div>
        <div>
          <FormHelperText>
            <span className={clsx(styles.acceptmentContent, styles[variant])}>
              Выражаю{" "}
              <AppLinkMui
                className={clsx(styles.acceptmentLink, styles[variant])}
                href="https://app.scb.ru/policy/"
                target="_blank"
                rel="noopener noreferrer"
                underline="always"
              >
                согласие
              </AppLinkMui>{" "}
              на&nbsp;обработку персональных данных и&nbsp;подтверждаю, что&nbsp;ознакомлен с&nbsp;
              <AppLinkMui
                className={clsx(styles.acceptmentLink, styles[variant])}
                href="https://scb.ru/about/pages/policy-personal-data"
                target="_blank"
                rel="noopener noreferrer"
                underline="always"
              >
                Политикой
              </AppLinkMui>{" "}
              обработки персональных данных
            </span>
          </FormHelperText>
        </div>
      </div>
      <FormHelperText error classes={{ root: clsx(styles.acceptmentError, styles[variant]) }}>
        {error}
      </FormHelperText>
    </div>
  </WrapperDataLayer>
)
